import { Component, OnInit, Input, OnChanges, HostListener, ElementRef, OnDestroy } from '@angular/core';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { PaymentsService } from 'src/app/services/payments-services/payments.service';
import { Gateway } from 'src/app/models/gateways-models/gateway.model';
import { GatewayProvider } from 'src/app/models/gateways-models/gateway-provider.model';
import { GatewayType } from 'src/app/models/gateways-models/gateway-type.model';

@Component({
  selector: 'app-payments-gateway-info-card',
  templateUrl: './payments-gateway-info-card.component.html',
  styleUrls: ['./payments-gateway-info-card.component.scss']
})
export class PaymentsGatewayInfoCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() gateway: Gateway;
  @Input() providers: Array<GatewayProvider>;
  @Input() types: Array<GatewayType>;
  editingLocked;
  updateGatewayInfoSubscription;
  basicDataForm = new FormGroup({
    active: new FormControl({ value: null, disabled: true }),
    name: new FormControl({ value: null, disabled: true }, Validators.required),
    provider: new FormControl({ value: null, disabled: true }, Validators.required),
    type: new FormControl({ value: null, disabled: true }, Validators.required),
    invoicePrefix: new FormControl({ value: null, disabled: true }),
    accessOnsite: new FormControl({ value: null, disabled: true }),
    accessOnline: new FormControl({ value: null, disabled: true })
  });

  constructor(private paymentsService: PaymentsService,
              private snackbarService: SnackBarService,
              private eRef: ElementRef) {
                this.editingLocked = true;
              }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.gateway) {
      this.resetForm();
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {
    } else {
      if (event.path[0].className !== 'mat-option-text') {
        if (this.gateway && !this.editingLocked) {
          this.resetForm();
          this.lockEdition();
        }
      }
    }
  }

  public toggleEdition() {
    if (this.editingLocked) {
      this.unlockEdition();
    } else {
      const validation = this.validateForm();
      if (validation === true) {
        this.submitForm();
        this.lockEdition();
      }
    }
  }

  public submitForm() {
    const validation = this.validateForm();
    if (validation) {
      this.updateGatewayInfoSubscription = this.paymentsService.updateGatewayInfo(this.gateway.InternalId, this.basicDataForm).subscribe(
        (res) => {
          this.editingLocked = true;
          this.snackbarService.open('gateways-page.snackbar messages.update gateway success', 'success');
          this.paymentsService.refreshGateway();
        },
        (error) => {
          this.snackbarService.open(error['error']['message'], 'error');
          this.paymentsService.refreshGateway();
        }
      );
    } else {
      this.snackbarService.open(validation, 'error');
    }
  }

  public validateForm() {
    if (!this.basicDataForm.get('name').valid) {
      return 'gateways-page.snackbar messages.name gateway error';
    } else {
      return true;
    }
  }

  public resetForm() {
    this.basicDataForm.patchValue({
      active: this.gateway.Active,
      name: this.gateway.Name,
      provider: this.gateway.Gateway,
      type: this.gateway.Type,
      invoicePrefix: this.gateway.InvoicePrefix,
      accessOnsite: this.gateway.AccessOnsite,
      accessOnline: this.gateway.AccessOnline
    });
  }

  public unlockEdition() {
    this.basicDataForm.get('active').enable();
    this.basicDataForm.get('name').enable();
    this.basicDataForm.get('provider').enable();
    this.basicDataForm.get('type').enable();
    this.basicDataForm.get('invoicePrefix').enable();
    this.basicDataForm.get('accessOnsite').enable();
    this.basicDataForm.get('accessOnline').enable();
    this.editingLocked = false;
  }

  public lockEdition() {
    this.basicDataForm.get('active').disable();
    this.basicDataForm.get('name').disable();
    this.basicDataForm.get('provider').disable();
    this.basicDataForm.get('type').disable();
    this.basicDataForm.get('invoicePrefix').disable();
    this.basicDataForm.get('accessOnsite').disable();
    this.basicDataForm.get('accessOnline').disable();
    this.editingLocked = true;
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.InternalId === op2.InternalId;
    }
  }

  ngOnDestroy() {
    if (this.updateGatewayInfoSubscription) { this.updateGatewayInfoSubscription.unsubscribe(); }
  }
}
